import * as React from "react";
import { IOWidget, mk_widget, option, Options } from "../widget";

export type CheckboxOptions<a> = Options & {
  selected_value:a,
  unselected_value:a,
}

interface CheckboxProps<a> {
  options:CheckboxOptions<a>
  input:a,
  on_done:(output:a) => void
}
interface CheckboxState<_a> { }

class Checkbox<a> extends React.Component<CheckboxProps<a>, CheckboxState<a>> {
  constructor(props:CheckboxProps<a>, context:any) {
    super(props, context)

    this.state = {}
  }

  render() {
    return <input  {...(option("extraProperties", this.props.options) || {})}
              id={option("id", this.props.options)}
              className={option("className", this.props.options)}
              key={this.props.options ? this.props.options.key : undefined}
              readOnly={this.props.options && this.props.options.readonly}
              type={"checkbox"}
              checked={this.props.input == this.props.options.selected_value}
              onChange={e => {
                this.props.on_done(e.currentTarget.checked ?
                  this.props.options.selected_value
                : this.props.options.unselected_value)
              } } />
  }
}

/** @deprecated Use [[wrapHTML]] instead. */
export const checkbox = function<a>(options:CheckboxOptions<a>) : IOWidget<a, a> {
  return (input:a) => mk_widget({
    run:(on_done:(output:a) => void) =>
      React.createElement<CheckboxProps<a>>(Checkbox, { on_done, input, options })
  })
}

/** @deprecated Use [[wrapHTML]] instead. */
export const bool = function(options?:Options) : IOWidget<boolean, boolean> {
  return checkbox<boolean>({...options || {}, selected_value:true, unselected_value:false })
}
